<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableNatGateway",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      //accountIdList: [],
      name: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.ALI.Vpc.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.name"),
          key: "name",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.natGatewayId"),
          key: "natGatewayId",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.state"),
          key: "state",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.publicIp"),
          key: "publicIp",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.privateIp"),
          key: "privateIp",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.vpcId"),
          key: "vpcId",
        },
        {
          title: this.$t("RAM.ALI.NatGateway.createTime"),
          key: "createTime",
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (companyId) {
      tableDataVue.companyId = companyId;
    });
    eventBus.$on("accountName", function (accountName) {
      tableDataVue.accountName = accountName;
    });
    eventBus.$on("accountIdList", function (accountIdList) {
      tableDataVue.accountIdList = accountIdList;
    });
    eventBus.$on("natGatewayId", function (natGatewayId) {
      tableDataVue.natGatewayId = natGatewayId;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (companyId) {
        tableDataVue.companyId = companyId;
      });
      eventBus.$on("accountName", function (accountName) {
        tableDataVue.accountName = accountName;
      });
      eventBus.$on("accountIdList", function (accountIdList) {
        tableDataVue.accountIdList = accountIdList;
      });
      eventBus.$on("natGatewayId", function (natGatewayId) {
        tableDataVue.natGatewayId = natGatewayId;
      });
      this.$api.resourceManagement
        .pagingQueryAliNatGateway({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableDataVue.companyId,
          accountName: tableDataVue.accountName,
          accountIdList: tableDataVue.accountIdList,
          natGatewayId: tableDataVue.natGatewayId,
          accountType: 1,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/natGateway/TableNatGateway.vue